export default __webpack_public_path__ + "static/media/aboutHero.ee296c92.jpg";